import { render, staticRenderFns } from "./ruPrivacy.vue?vue&type=template&id=25f3a142&scoped=true&"
import script from "./ruPrivacy.vue?vue&type=script&lang=js&"
export * from "./ruPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./ruPrivacy.vue?vue&type=style&index=0&id=25f3a142&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f3a142",
  null
  
)

export default component.exports